import Cookies from "universal-cookie";

const cookies = new Cookies();

export function saveData(key,data) {
    cookies.set(key, data, { path: '/' });
}

export function getData(key) {
    return cookies.get(key);
}

export function removeData(key) {
    cookies.remove(key);
}
